import { AccessGuids, ConfigSystemParams, DgActionColumnWidth, DgAlignment, DgColumnDataType, DgColumnSortOrder, DgColumnWidths, DgSelectionCheckBoxMode, DgSummaryType, eSimApiPaths, FieldAliases, FlatpickrFormat, GridViewTitles, Hosts_DevicesAllocatedContentSharedComponent, StorageValues } from 'src/app/core/consts';
import { ActivatedRoute, Router } from '@angular/router';
import { AuthenticationService } from 'src/app/core/services/auth.service';
import { BooleanService } from 'src/app/core/services/utelize/general/boolean-service';
import { BulkSimAction, BulkSimActionsModalFormComponent } from 'src/app/forms-modal/_manage-sim/bulk-sim-actions-modal-form/bulk-sim-actions-modal-form.component';
import { catchError, firstValueFrom, Subscription, throwError } from 'rxjs';
import { CompaniesService } from 'src/app/core/services/utelize/system/company/companies-service';
import { CompanyModalFormComponent } from 'src/app/forms-modal/_company/company-modal-form/company-modal-form.component';
import { CompanySelectEvent } from 'src/app/core/interfaces/events/event-select-company';
import { Component, EventEmitter, Input, OnChanges, OnDestroy, OnInit, Output, SimpleChanges, TemplateRef, ViewChild } from '@angular/core';
import { ComponentAccessUserService } from 'src/app/core/services/utelize/system/component-access/component-access-user-service';
import { ConfigSystemService } from 'src/app/core/services/utelize/system/config-system/config-system-service';
import { CommunicationComposeModalFormComponent } from 'src/app/forms-modal/_communication/communication-compose-modal-form/communication-compose-modal-form.component';
import { CountriesService } from 'src/app/core/services/utelize/system/mapping/countries-service';
import { DatePipe } from '@angular/common';
import { DgActionColumn } from 'src/app/core/interfaces/datagrid/dg-action-column';
import { DgApiPath } from 'src/app/core/interfaces/datagrid/dg-api-paths';
import { DgCellIcon, DgColumn } from 'src/app/core/interfaces/datagrid/dg-column';
import { DgPopup } from 'src/app/core/interfaces/datagrid/dg-pop-up';
import { DgProperties } from 'src/app/core/interfaces/datagrid/dg-properties';
import { DgTab } from 'src/app/core/interfaces/datagrid/dg-tab';
import { DropdownService } from 'src/app/core/services/utelize/general/dropdown-service';
import { EncryptAesClientSide } from 'src/app/core/encryption';
import { EncryptionService } from 'src/app/core/services/utelize/general/encryption-service';
import { environment } from 'src/environments/environment';
import { eUser, LimitTypeName } from 'src/app/core/enums';
import { ExceptionsService } from 'src/app/core/services/utelize/general/exceptions-service';
import { GridViewComponent } from 'src/app/core/grid-view/component/grid-view.component';
import { GridViewDefaults } from 'src/app/core/grid-view/component/grid-view.defaults';
import { GridViewService } from 'src/app/core/services/utelize/general/grid-view.service';
import { ManageEsimModalFormComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form/manage-esim-modal-form.component';
import { ManageEsimModalFormMoreComponent } from 'src/app/forms-modal/_manage-sim/manage-esim-modal-form-more/manage-esim-modal-form-more.component';
import { MdmIntuneSimExceptionsService } from 'src/app/core/services/utelize/system/device-management/mdm-intune-sim-exceptions-service';
import { MenuItem } from 'primeng/api';
import { NgbNav } from '@ng-bootstrap/ng-bootstrap';
import { OrderDevicesAllocatedStatsDTO, OrderDevicesAllocatedStatsDTO_EmptyObject } from 'src/app/core/models/system/order/order-devices-allocated-stats.dto';
import { OrderMiniDTO } from 'src/app/core/models/system/order/order-mini.dto';
import { OrdersService } from 'src/app/core/services/utelize/system/order/orders-service';
import { OurDate } from 'src/app/core/interfaces/general/our-date';
import { PageCompMenuPrimeNgComponent } from 'src/app/core/page-components/page-comp-menu-primeng/page-comp-menu-primeng.component';
import { populateOurDate } from 'src/app/core/functions-generic/functions-generic-date';
import { RiskIntelligenceAccessService } from 'src/app/core/services/utelize/access/risk-intelligence/risk-intelligence-access.service';
import { RisklineTripReadyModalFormComponent } from 'src/app/forms-modal/riskline-trip-ready-modal-form/riskline-trip-ready-modal-form.component';
import { SimStatusService } from 'src/app/core/services/utelize/general/sim-status-service';
import { SystemUserDTO } from 'src/app/core/models/system/user/system-user.dto';
import { TimelineEsimModalFormComponent } from 'src/app/forms-modal/_time-line/timeline-esim-modal-form/timeline-esim-modal-form.component';
import { TopBarService } from 'src/app/core/services/utelize/general/top-bar-service';
import { UserModalFormComponent } from 'src/app/forms-modal/_user/user-modal-form/user-modal-form.component';
import { UsersService } from 'src/app/core/services/utelize/system/user/users-service';
import { Validators } from '@angular/forms';

const apiPath             =environment.eSimApi+eSimApiPaths.Orders;
const exportFilenameSuffix="Allocated-SIM-Data";
const mainTitle           =GridViewTitles.devicesAllocatedContentShared;
const mainTitleVersion2   ="Allocated SIMs";
const pathMain            ="SIM MANAGEMENT";
const pathParent          ="SIM";
const pathThis            =GridViewTitles.devicesAllocatedContentShared;
const popUpTitle          ="Allocated SIM";

@Component({
  selector: 'app-devices-allocated-content-shared',
  templateUrl: './devices-allocated-content-shared.component.html',
  styleUrls: ['./devices-allocated-content-shared.component.scss'],
  providers: [DatePipe]
})

export class DevicesAllocatedContentSharedComponent implements OnChanges, OnDestroy, OnInit {
  
  @Input() compactMode         : boolean  | undefined;
  @Input() countryIsoCodes     : string[] | undefined;
  @Input() defaultSortBy       : string   | undefined;
  @Input() defaultSortOrder    : "asc"    | "desc" | undefined;
  @Input() excludeIotDevices   : boolean  | undefined;
  @Input() hostComponent       : string   | undefined;
  @Input() hostIsReseller      : boolean  | undefined;
  @Input() showFilterRowInitial: boolean  | undefined;
  @Input() topNLimit           : number   | undefined;  
  @Input() travellersAbroadOnly: boolean  | undefined;

  @Output() companyDataSaved: EventEmitter<void>=new EventEmitter<void>();

  @ViewChild('ArrowNgbNav'                                     ) arrowNav!                     : NgbNav;
  @ViewChild('bulkSimActions',                { static: false }) bulkSimActions!               : BulkSimActionsModalFormComponent;
  @ViewChild('communicationComposeModalForm', { static: false }) communicationComposeModalForm!: CommunicationComposeModalFormComponent;
  @ViewChild('companyModalForm',              { static: false }) companyModalForm!             : CompanyModalFormComponent;
  @ViewChild('gridView',                      { static: false }) gridView!                     : GridViewComponent;
  @ViewChild('manageEsimModalForm',           { static: false }) manageEsimModalForm!          : ManageEsimModalFormComponent;
  @ViewChild('manageEsimForm',                { static: false }) manageEsimForm!               : TemplateRef<void>;
  @ViewChild('manageEsimMore',                { static: false }) manageEsimMore!               : ManageEsimModalFormMoreComponent;
  @ViewChild('morePopupMenu'                                   ) morePopupMenu!                : PageCompMenuPrimeNgComponent;
  @ViewChild('riskTripReadyModalForm',        { static: false }) riskTripReadyModalForm!       : RisklineTripReadyModalFormComponent;
  @ViewChild('timelineModalForm',             { static: false }) timelineModalForm!            : TimelineEsimModalFormComponent;
  @ViewChild('userModalForm',                 { static: false }) userModalForm!                : UserModalFormComponent;
  
  get canBulkAction       () { return this.selectedSims.length>0                                                           ; }
  get hostShowsAsDashboard() { return this.hostComponentIsDashboardComponent || this.hostComponentIsUsageDashboardComponent; }
  get showBulkToolbar     () { return this.hostComponentIsDevicesAllocatedComponent===true
                                      && this.canShowBulkActions
                                      && this.activeId===this.navItemLog_Live                                              ; }
  get showLocationButton  () { return this.hostComponentIsTravelRiskManagementComponent                                    ; }
  get showMessageButton   () { return this.hostComponentIsTravelRiskManagementComponent                                    ; }
  get showRiskColumn      () { return this.riskIntelligenceAccessService.canShow()                                         ; }

  get companyTopLevelSelect() { return this.componentAccessUserService.hasAccessGuid(AccessGuids.DropdownsCompanyTopLevelSelect, true); }
  get showCeasedCompanies  () { return this.hostComponentIsDevicesAllocatedComponent===true &&
                                       this.componentAccessUserService.hasAccessGuid(AccessGuids.GridCompaniesShowCeased,        true); }
  
  get fieldAliasUsername() { return this.configSystemService.getValue(ConfigSystemParams.FieldAliasUsername, FieldAliases.FieldAliasUsername); }

  get canShowBulkActions        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimBulkActionsEnabled,     false) &&
                                            this.componentAccessUserService.hasAccessGuid(AccessGuids.GridDevicesAllocatedBulkActions,          true ); }
  get intuneExceptionColumn     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowFullname,           true )
                                            ? "fullName"
                                            : "username"                                                                                              ; }
  get manageEsimVersion2        () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ManageEsimVersion2,                   false); }
  get showTimelineAsModal       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.ShowTimelineAsModal,                  false); }
  get showLastUsageColumn       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowLastUsage,          false); }
  get showLimitUsedColumn       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowLimitUsed,          false); }
  get showSummaryCost           () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowSummaryCost,        false); }
  get showSummaryUsage          () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowSummaryUsage,       false); }
  get showSummaryUsageLimit     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowSummaryUsageLimit,  false); }
  get showUsageLimitColumn      () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowUsageLimit,         false); }
  get showWidgets               () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowWidgets,            false); }
  get superHierarchyEnabled     () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.DropdownCompanySuperHierarchyEnabled, false); }
  get titlesEmbedCompanyDropDown() { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedCompanyDropDown,      true ); }
  get titlesEmbedDateDropDown   () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.PagesTitlesEmbedDateDropDown,         true ); }
  get useServerSidePaging       () { return this.configSystemService.getValueAsBoolean(ConfigSystemParams.UseServerSidePagingOrders,            false); }
  
  get columnMinWidth    () { return this.configSystemService.getValueAsInteger(ConfigSystemParams.GridManageEsimColumnMinWidth,     150); }
  get nearLimitThreshold() { return this.configSystemService.getValueAsInteger(ConfigSystemParams.GridManageEsimNearLimitThreshold,  80); }

  get isCurrentMonth() {
    const now=new Date();

    return Number(this.filterDate?.year  ?? -1)===now.getFullYear() &&
           Number(this.filterDate?.month ?? -1)===now.getMonth()+1;
  }

  get selectedMonthLabel(): string {
    const year =Number(this.filterDate?.year  ?? 0);
    const month=Number(this.filterDate?.month ?? 0);

    if (!year || !month)
      return '';

    const date=new Date(year, month - 1, 1);
    
    return date.toLocaleString('en-GB', { month: 'long', year: 'numeric' });
  }
  
  private liveStatues           : string[]=["Live", "Live - Barred","Live - Suspended", "Live - Throttled 64Kbps", "Live - Throttled 512Kbps", "Live - Alert Product", "Awaiting Download", "Awaiting Deployment", "Downloaded", "Disabled", "Removed", "Sent - SMS/email"];
  private ceasedStatues         : string[]=["Ceased"];
  // private removedStatues      : string[]=["Removed"];

  //private baseColumnList      : string[]=["orderNo", "companyName", "username", "imeiIccid", "deviceType", "internalProductName", "provisionedDate" ,"orderSpendDTO.usage", "orderSpendDTO.cost", "orderSpendDTO.usageLimit", "orderSpendDTO.limitUsed", "orderSpendDTO.lastCountry", "status", "orderSpendDTO.lastUsage"];

  private apiPathGetSeq                     : number=0;
  private appliedFilterKey                  : string='';
  private companyModalFormIsOpen            : boolean=false;
  private curUser                           : SystemUserDTO;
  private gridViewDefaults!                 : GridViewDefaults;
  private devExtremeMoreEvent               : any;
  private lastLoadKey                       : string | undefined;
  private manageEsimFormIsOpen              : boolean=false;
  private manageMoreFormIsOpen              : boolean=false;
  private originIsoCached                   : string='';
  private pendingCompanyId                  : number | undefined;
  private pendingOpenSimFormFromFilter      : boolean=false;
  private pendingSimCompanyResolveInProgress: boolean=false;
  private riskTripReadyModalFormIsOpen      : boolean=false;
  private routeQueryParamSub                : Subscription | undefined;
  private statsSub                          : Subscription | undefined;
  private userModalFormIsOpen               : boolean=false;

  public activeId                   : number = 1;
  public breadCrumbItems!           : Array<{}>;
  public BulkSimAction              =BulkSimAction;
  public dgActionColumn!            : DgActionColumn | undefined;
  public dgApiPath!                 : DgApiPath | undefined;
  public dgColumns!                 : Array<DgColumn>;
  public dgPopup!                   : DgPopup | undefined;
  public dgProperties!              : DgProperties | undefined;
  public dgTabs!                    : Array<DgTab>;
  public effectiveNearLimitThreshold: number=80;
  public filterCompanyID            : number | undefined;
  public filterDate                 : OurDate | undefined=populateOurDate(this.exceptionsService, Date.now());
  public filterDateFormat           : string=FlatpickrFormat.MonthWordFull_Year;
  public gotDgProperties            : boolean=false;
  public includeCeased              : boolean=false;
  public isReseller                 : boolean=true;
  public pendingSimFilter           : string | undefined;
  public selectedSims               : any[]=[];
  public selectedStat               : string='';
  public showSpinner                : boolean=false;
  public statsActive                : number=0;
  public statsAlerting              : number=0;
  public statsAwaiting              : number=0;
  public statsCeasedThisMonth       : number=0;
  public statsHidden                : boolean=true;
  public statsNearLimit             : number=0;
  public statsNewInMonth            : number=0;
  public statsNewToday              : number=0;
  public statsOverLimit             : number=0;
  public statsTotal                 : number=0;
  public statsZeroUsage             : number=0;
  public title                      : string=this.manageEsimVersion2 ? mainTitleVersion2 : mainTitle;

  //#region Host Components
 
  public hostComponentIsDashboardComponent           : boolean=false;
  public hostComponentIsDevicesAllocatedComponent    : boolean=false;
  public hostComponentIsTravelRiskManagementComponent: boolean=false;
  public hostComponentIsUsageDashboardComponent      : boolean=false;

  //#endregion

  //#region More Menu

  private readonly menuItemLiveView ="Live View";
  private readonly menuItemManageSIM="Manage SIM";
  
  public moreMenuItems: MenuItem[]=[
    { label: this.menuItemManageSIM, command: () => this.onMoreMenuClick(this.menuItemManageSIM) },
    { label: this.menuItemLiveView,  command: () => this.onMoreMenuClick(this.menuItemLiveView)  }
  ];

  //#endregion

  //#region NavItems
 
  public navItemLog_Live   : number=1;
  public navItemLog_Ceased : number=2;
  // public navItemLog_Removed      : number=3;
  
  //#endregion

  constructor(
    private authenticationService        : AuthenticationService,
    private booleanService               : BooleanService,
    private companiesService             : CompaniesService,
    private componentAccessUserService   : ComponentAccessUserService,
    private configSystemService          : ConfigSystemService,
    private countriesService             : CountriesService,
    private datePipe                     : DatePipe,
    private dropdownService              : DropdownService,
    private encryptionService            : EncryptionService,
    private exceptionsService            : ExceptionsService,
    private gridViewService              : GridViewService,
    private mdmIntuneSimExceptionsService: MdmIntuneSimExceptionsService,
    private ordersService                : OrdersService,
    private riskIntelligenceAccessService: RiskIntelligenceAccessService,
    private route                        : ActivatedRoute,
    private router                       : Router,
    private simStatusService             : SimStatusService,
    private topBarService                : TopBarService,
    private usersService                 : UsersService
  ) {
    this.curUser         =this.authenticationService.currentUserObject();
    this.filterCompanyID =this.dropdownService.trackerCompanyId ?? (this.companyTopLevelSelect ? 0-this.curUser.companyId : this.curUser.companyId);
    this.gridViewDefaults=new GridViewDefaults(this.authenticationService, this.componentAccessUserService, this.configSystemService, this.exceptionsService);
  }

  public async ngOnInit(): Promise <void> {
    try {
      this.showSpinner=true;

      this.breadCrumbItems = [
        { label: pathMain },
        { label: pathParent },
        { label: pathThis, active: true }
      ];
      this.validateHostComponent();
      this.loadStatsVisibility();
      await this.mdmIntuneSimExceptionsService.ensureInitialised();

      this.pendingSimFilter=this.route.snapshot.queryParamMap.get('sim')?.trim()
                            || this.route.snapshot.queryParamMap.get('iccid')?.trim()
                            || undefined;
      this.pendingOpenSimFormFromFilter=this.parseBooleanQueryValue(this.route.snapshot.queryParamMap.get('openForm'));
      this.pendingCompanyId            =this.parsePositiveCompanyId(this.route.snapshot.queryParamMap.get('companyId'));

      if (this.pendingCompanyId) {
        this.filterCompanyID=this.pendingCompanyId;

      } else {
        this.resolvePendingCompanyFromSimFilter();
      }

      this.routeQueryParamSub?.unsubscribe();
      this.routeQueryParamSub=this.route.queryParamMap.subscribe(params => {
        this.pendingSimFilter            =params.get('sim')?.trim() || params.get('iccid')?.trim() || undefined;
        this.pendingOpenSimFormFromFilter=this.parseBooleanQueryValue(params.get('openForm'));
        this.pendingCompanyId            =this.parsePositiveCompanyId(params.get('companyId'));

        if (this.pendingCompanyId) {
          this.filterCompanyID=this.pendingCompanyId;

        } else {
          this.resolvePendingCompanyFromSimFilter();
        }

        this.applyPendingSimFilter();
      });
      
      await this.riskIntelligenceAccessService.ensureInitialised();
      await this.resolveOriginCountryIso();
      await this.setUpDgProperties();
      await this.setUpDgApiPaths();
      this.setUpDgActionColumn();
      this.setUpDgColumns(true);
      this.applyDefaultSort();
      this.setUpDgTabs();
      this.setUpDgPopup();

      this.topBarService.showAdd_Company_SimProv_SupportTicket_UserPortal_UserSim();

      this.gotDgProperties=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnChanges(changes: SimpleChanges): void {
    try {
      if (!this.gotDgProperties)
        return;

      if (changes['hostIsReseller']!=undefined && changes['hostIsReseller'].firstChange!=true)
        this.applyCompanyColumnVisibility();

      if (changes['countryIsoCodes']==undefined && changes['travellersAbroadOnly']==undefined && changes['excludeIotDevices']==undefined)
        return;

      if (changes['countryIsoCodes']?.firstChange==true || changes['travellersAbroadOnly']?.firstChange==true || changes['excludeIotDevices']?.firstChange==true)
        return;

      this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public ngOnDestroy(): void {
    try {
      this.routeQueryParamSub?.unsubscribe();
      this.statsSub?.unsubscribe();
      this.topBarService.hideAdd_Company_SimProv_SupportTicket_UserPortal_UserSim();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private applyDefaultSort(): void {
    try {
      if (!this.defaultSortBy || !this.dgColumns)
        return;

      this.dgColumns.forEach(col => {
        if (col.dataField===this.defaultSortBy) {
          col.sortOrder=this.defaultSortOrder ?? "desc";
          col.sortIndex=0;
        }
        else {
          col.sortOrder=undefined;
          col.sortIndex=undefined;
        }
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public triggerColumnChooser(anchorElement?: HTMLElement): void {
    try {
      const gridInstance:any=this.gridView?.dataGrid?.instance;

      if (!gridInstance)
        return;

      if (anchorElement) {
        gridInstance.option("columnChooser.position", {
          at       : "bottom right",
          collision: "fit",
          my       : "top right",
          of       : anchorElement
        });
      }

      gridInstance.showColumnChooser();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public triggerExport(format: "xlsx" | "pdf"="xlsx", selectedOnly: boolean=false): void {
    try {
      if (!this.gridView?.dataGrid?.instance)
        return;

      this.gridView.onExporting(<any>{
        component       : this.gridView.dataGrid.instance,
        format          : format,
        selectedRowsOnly: selectedOnly
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public triggerSearch(text: string): void {
    try {
      this.gridView?.dataGrid?.instance?.searchByText(text ?? "");
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public toggleFilterRow(): void {
    try {
      this.gridView?.toggleFilterRow();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public setTopNLimit(limit: number | undefined): void {
    try {
      this.topNLimit=limit;

      if (!this.gridView?.dataGrid?.instance)
        return;

      const newPageSize=limit!==undefined && limit>0 ? limit : 10;

      this.gridView.dataGrid.instance.option("paging.pageSize", newPageSize);

      if (this.dgProperties)
        this.dgProperties.pageSize=newPageSize;

      // Force a re-layout so the pager visibility CSS toggle takes effect immediately.
      setTimeout(() => {
        this.gridView?.dataGrid?.instance?.updateDimensions();
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public validateHostComponent(): void {
    try {
      if (!this.hostComponent) {
        throw new Error("DevicesAllocatedContentSharedComponent..hostComponent is undefined");
      }

      this.hostComponentIsDashboardComponent           =this.hostComponent==Hosts_DevicesAllocatedContentSharedComponent.DashboardComponent;
      this.hostComponentIsDevicesAllocatedComponent    =this.hostComponent==Hosts_DevicesAllocatedContentSharedComponent.DevicesAllocatedComponent;
      this.hostComponentIsTravelRiskManagementComponent=this.hostComponent==Hosts_DevicesAllocatedContentSharedComponent.TravelRiskManagementComponent;
      this.hostComponentIsUsageDashboardComponent      =this.hostComponent==Hosts_DevicesAllocatedContentSharedComponent.UsageDashboardComponent;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridContentReady() {
    try {
      this.showSpinner=false;

      this.applyCompanyColumnVisibility();
      this.keepFirstPageWhilePagerHidden();
      this.applyPendingSimFilter();
      this.tryOpenSingleFilteredSimForm();
      this.applyGridFilter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private keepFirstPageWhilePagerHidden(): void {
    try {
      if (this.topNLimit==undefined || this.topNLimit<=0)
        return;

      if (this.hostComponentIsTravelRiskManagementComponent)
        return;

      const instance=this.gridView?.dataGrid?.instance;

      if (!instance)
        return;

      //RBW_20260824 - Guarded so the resulting reload settles on page 0 rather than looping
      if (<number>instance.pageIndex()>0)
        instance.pageIndex(0);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyPendingSimFilter() {
    try {
      if (!this.gridView?.dataGrid?.instance)
        return;

      const pendingCompanyId=this.pendingCompanyId;

      if (pendingCompanyId) {
        this.pendingCompanyId=undefined;
        this.companyDropDownOnChange(pendingCompanyId, false);
        return;
      }

      const filterText=this.pendingSimFilter?.trim();

      if (!filterText) {
        this.tryOpenSingleFilteredSimForm();
        return;
      }

      setTimeout(() => {
        this.gridView?.dataGrid?.instance?.searchByText(filterText);
        this.tryOpenSingleFilteredSimForm();
      }, 0);

      this.pendingSimFilter=undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private parsePositiveCompanyId(value: string | null): number | undefined {
    try {
      const parsed=Number(value ?? '');

      return Number.isFinite(parsed) && parsed > 0 ? parsed : undefined;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  }

  private parseBooleanQueryValue(value: string | null): boolean {
    try {
      const normalized=(value ?? '').toString().trim().toLowerCase();
      
      return normalized==='1' || normalized==='true' || normalized==='yes' || normalized==='y';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private resolvePendingCompanyFromSimFilter() {
    try {
      if (this.pendingCompanyId || this.pendingSimCompanyResolveInProgress)
        return;

      const iccid=(this.pendingSimFilter ?? '').trim();

      if (!iccid)
        return;

      if (!this.isLikelyIccidValue(iccid))
        return;

      this.pendingSimCompanyResolveInProgress=true;

      this.ordersService.getOrderIdByIccid(iccid)
      .pipe(
        catchError((error) => {
          this.pendingSimCompanyResolveInProgress=false;
          return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
        })
      )
      .subscribe({
        next: orderIdResult => {
          const orderId=Number(orderIdResult?.result ?? -1);

          if (!Number.isFinite(orderId) || orderId <= 0) {
            this.pendingSimCompanyResolveInProgress=false;
            return;
          }

          this.ordersService.getById(orderId)
          .pipe(
            catchError((error) => {
              this.pendingSimCompanyResolveInProgress=false;
              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
            })
          )
          .subscribe({
            next: order => {
              this.pendingSimCompanyResolveInProgress=false;
              const companyId=Number(order?.companyID ?? -1);

              if (Number.isFinite(companyId) && companyId>0) {
                this.pendingCompanyId=companyId;
                this.filterCompanyID =companyId;
                this.applyPendingSimFilter();
              }
            },
            error: error => {
              this.pendingSimCompanyResolveInProgress=false;
              this.exceptionsService.handleException(new Error(error));
            }
          });
        },
        error: error => {
          this.pendingSimCompanyResolveInProgress=false;
          this.exceptionsService.handleException(new Error(error));
        }
      });
    }
    catch(e) {
      this.pendingSimCompanyResolveInProgress=false;
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private isLikelyIccidValue(value: string): boolean {
    try {
      const normalized=(value ?? '').replace(/\s+/g, '');

      return /^\d{10,22}$/.test(normalized);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private tryOpenSingleFilteredSimForm() {
    try {
      if (!this.pendingOpenSimFormFromFilter || this.manageEsimFormIsOpen)
        return;

      const gridInstance:any=this.gridView?.dataGrid?.instance;

      if (!gridInstance || typeof gridInstance.getVisibleRows!=='function')
        return;

      const rows    =(gridInstance.getVisibleRows?.() ?? []) as any[];
      const dataRows=rows.filter(row => row?.rowType==='data' && Number(row?.data?.id ?? -1) > 0);

      if (dataRows.length!==1)
        return;

      this.pendingOpenSimFormFromFilter=false;
      this.manageEsimFormIsOpen        =true;
      this.disableGridLoadPanel();
      this.manageEsimModalForm.openForm(Number(dataRows[0].data.id));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async onTabChange(event: any) {
    try {
      this.activeId = <number>event;
      this.dgColumns.forEach((column: DgColumn) => {

        //RBW_2025MMDD - Set the status filter
        if (column.dataField == "statusDisplay" ) {
          if (this.activeId == this.navItemLog_Live) {
            column.filterValues = this.simStatusService.toStatusDisplays(this.liveStatues);
          } else if (this.activeId == this.navItemLog_Ceased) {
            column.filterValues = this.simStatusService.toStatusDisplays(this.ceasedStatues);
          } 
          // else if (this.activeId == this.navItemLog_Removed) {
          // column.filterValues = this.removedStatues;
          // }
        }
      });

      if (this.activeId!==this.navItemLog_Live) {
        this.selectedSims=[];
        this.gridView?.dataGrid?.instance?.clearSelection();
      }

      this.applyBulkSelectionMode();

      await this.setDgApiPathGet();
      this.setUpDgColumns(false);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private companyColumnIsUseful(): boolean {
    try {
      if (this.hostIsReseller==true)
        return true;

      return (this.filterCompanyID ?? 0)<0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return true;
    }
  }

  private travelRiskVisibleColumns(): string[] {
    try {
      return [
        "fullName",
        "deviceModelDisplay",
        "imeiIccid",
        "statusDisplay",
        "locationAccuracyDisplay",
        "orderSpendDTO.lastCountry",
        "orderSpendDTO.lastUsage"
      ];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return [];
    }
  }

  private travelRiskColumnIsVisible(dataField: string): boolean {
    try {
      if (dataField=="companyName")
        return this.companyColumnIsUseful();

      return this.travelRiskVisibleColumns().includes(dataField);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private applyCompanyColumnVisibility(): void {
    try {
      if (!this.hostComponentIsTravelRiskManagementComponent)
        return;

      const visible: boolean=this.companyColumnIsUseful();
      const column          =this.dgColumns?.find(x => x.dataField=='companyName');

      if (column!=undefined)
        column.gridVisible=visible;

      this.gridView?.dataGrid?.instance?.columnOption('companyName', 'visible', visible);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private buildLoadKey(): string {
    try {
      return JSON.stringify([
        this.filterCompanyID ?? -1,
        this.filterDate?.year ?? 1,
        this.filterDate?.month ?? 1,
        this.hostShowsAsDashboard,
        this.buildTravelRiskParams(),
        this.buildCeasedParams(),
        this.dgProperties?.remoteOperations==true
      ]);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private buildCeasedParams(): string {
    try {
      return this.showCeasedCompanies && this.includeCeased ? "&includeCeased=true" : "";
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return "";
    }
  }

  private buildTravelRiskParams(): string {
    try {
      let   params  : string='';
      const isoCodes: string[]=(this.countryIsoCodes ?? []).map(iso => (iso ?? '').trim().toUpperCase())
                                                           .filter(iso => iso!='');

      if (isoCodes.length>0)
        params+="&countryIsoCodes=" + encodeURIComponent(isoCodes.join(','));

      if (this.travellersAbroadOnly==true)
        params+="&travellersAbroadOnly=true";

      if (this.excludeIotDevices==true)
        params+="&excludeIotDevices=true";

      return params;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public async setDgApiPathGet(skipIfUnchanged: boolean=false) {
    try {
      if (this.dgProperties != undefined && this.dgApiPath != undefined)
      {
        const loadKey: string=this.buildLoadKey();

        if (skipIfUnchanged && loadKey===this.lastLoadKey)
          return;

        this.lastLoadKey=loadKey;
        this.showSpinner=true;

        const companyID         =this.filterCompanyID == undefined ? "-1" : this.filterCompanyID;
        const companyIdToEncrypt=<string><unknown>companyID;
        const seq               =++this.apiPathGetSeq;
        const companyIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(companyIdToEncrypt, true));

        if (seq!==this.apiPathGetSeq)
          return;

        const companyIdEncSS    =companyIdEncResult.result;

        var params = "?companyIdEncSS="           + companyIdEncSS +
                     "&year="                     + <number>(this.filterDate?.year ?? 1) +
                     "&month="                    + <number>(this.filterDate?.month ?? 1) +
                     "&day=1"                     +
                     "&activeDuringMonthOnly="    + this.hostShowsAsDashboard +
                     this.buildTravelRiskParams() +
                     this.buildCeasedParams();

        if (this.dgProperties!.remoteOperations==true) {
          this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Orders + "/" + eSimApiPaths.OrdersActiveOnlyServerSide + params;
        }
        else {
          this.dgApiPath!.get=environment.eSimApi+eSimApiPaths.Orders + "/" + eSimApiPaths.OrdersActiveOnly + params;
        }

        this.gridViewService.apiPathGet=this.dgApiPath!.get;
        if (this.gridView != null) {
          this.gridView.refreshData();
        }

        this.loadStats(companyIdEncSS);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async setUpDgApiPaths() {
    try {
      const companyID         =0;
      const companyIdToEncrypt=<string><unknown>companyID;
      const companyIdEncResult=await firstValueFrom(this.encryptionService.encrypt_AesServerSideForWeb(companyIdToEncrypt, true));
      const companyIdEncSS    =companyIdEncResult.result;
      
      var params = "?companyIdEncSS="           + companyIdEncSS +
                   "&year="                     + <number>(this.filterDate?.year ?? 1) +
                   "&month="                    + <number>(this.filterDate?.month ?? 1) +
                   "&day=1"                     +
                   "&activeDuringMonthOnly="    + this.hostShowsAsDashboard +
                   this.buildTravelRiskParams() +
                   this.buildCeasedParams();
      
      if (this.dgProperties!.remoteOperations==true) {
        this.dgApiPath     =this.gridViewDefaults.setUpDgApiPaths(apiPath + "/" + eSimApiPaths.OrdersActiveOnlyServerSide + params);
      } 
      else {
        this.dgApiPath     =this.gridViewDefaults.setUpDgApiPaths(apiPath + "/" + eSimApiPaths.OrdersActiveOnly + params);
      }
      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgActionColumn() {
    try {
      this.dgActionColumn                            =this.gridViewDefaults.setUpDgActionColumn();
      const oneButton                                =this.manageEsimVersion2 && !this.hostShowsAsDashboard;
      const baseWidth                                =oneButton ? DgActionColumnWidth.oneButtonWithLeftRightPadding : DgActionColumnWidth.twoButtonsWithLeftRightPadding;
      const riskExtraWidth                           =this.showRiskColumn ? (DgActionColumnWidth.twoButtonsWithLeftRightPadding - DgActionColumnWidth.oneButtonWithLeftRightPadding) : 0;
      const showLocation                             =this.showLocationButton;
      const locationExtraWidth                       =showLocation ? (DgActionColumnWidth.twoButtonsWithLeftRightPadding - DgActionColumnWidth.oneButtonWithLeftRightPadding) : 0;
      const showMessage                              =this.showMessageButton;
      const messageExtraWidth                        =showMessage ? DgActionColumnWidth.messageButton : 0;
      const actionColumnWidth                        =baseWidth + riskExtraWidth + locationExtraWidth + messageExtraWidth;
      this.dgActionColumn!.allowDeleting             =false;
      this.dgActionColumn!.allowLocation             =showLocation;
      this.dgActionColumn!.allowMessage              =showMessage;
      this.dgActionColumn!.messageRowButtonCondition =this.messageColumnCondition;
      this.dgActionColumn!.allowMore                 =!oneButton;
      this.dgActionColumn!.allowRisk                 =this.showRiskColumn;
      this.dgActionColumn!.fixed                     =true;
      this.dgActionColumn!.fixedPosition             ="right";
      this.dgActionColumn!.locationIcon              ="assets/images/_suresim/Button Location 55x23.png";
      this.dgActionColumn!.locationRowButtonCondition=this.locationColumnCondition;
      this.dgActionColumn!.minWidth                  =actionColumnWidth;
      this.dgActionColumn!.moreIcon                  ="assets/images/_suresim/Button View 55x23.png";
      this.dgActionColumn!.riskRowButtonCondition    =this.riskColumnCondition;
      this.dgActionColumn!.updateIcon                ="assets/images/_suresim/Button Manage 55x23.png";
      this.dgActionColumn!.width                     =actionColumnWidth;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgPopup() {
    try {
      this.dgPopup               =this.gridViewDefaults.setUpDgPopup(popUpTitle);
      this.dgPopup!.overridePopup=true;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private sleep(ms: number): Promise<void> {
  return new Promise(resolve => setTimeout(resolve, ms));
}

  private async setUpDgProperties() {
    try {
      while (this.configSystemService.paramsLoaded == false) {
        await this.sleep(1000);
      }
      
      this.dgProperties                     =this.gridViewDefaults.setUpDgProperties(mainTitle, exportFilenameSuffix);
      this.dgProperties!.cacheEnabled       =this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridCacheEnabled);
      this.dgProperties!.checkbox0          =this.gridViewDefaults.setUpDgCheckbox("Horizontal Scroll & Fixed Columns",
                                                                                   true,
                                                                                   false,
                                                                                   false,
                                                                                   (this.hostComponentIsDashboardComponent
                                                                                    || this.hostComponentIsDevicesAllocatedComponent
                                                                                    || this.hostComponentIsUsageDashboardComponent)
                                                                                   && this.columnMinWidth>0);
      this.dgProperties!.checkbox1          =this.gridViewDefaults.setUpDgCheckbox("Include - Ceased",
                                                                                   true,
                                                                                   false,
                                                                                   false,
                                                                                   this.showCeasedCompanies);
      this.dgProperties!.columnHidingEnabled=false;
      this.dgProperties!.columnMinWidth     =undefined;
      this.dgProperties!.encryptDeleteSS    =true;
      this.dgProperties!.encryptPost        =true;
      this.dgProperties!.encryptPut         =true;
      this.dgProperties!.gridKey            ="DevicesAllocatedContentShared";
      this.dgProperties!.autoNavigateToFocusedRow=false;

      this.dgProperties!.initialTab         =this.navItemLog_Live;

      this.applyBulkSelectionMode();

      this.dgProperties!.remoteOperations   =this.configSystemService.getValueAsBoolean(ConfigSystemParams.UseServerSidePagingOrders);
      this.dgProperties!.showAddButton      =false;
      this.dgProperties!.showRefreshButton  =true;
      this.dgProperties!.showTabs           =true;

      if (this.hostComponentIsUsageDashboardComponent || this.hostComponentIsTravelRiskManagementComponent)
        this.dgProperties!.skipStickyLayout=true;

      if (this.hostComponentIsTravelRiskManagementComponent)
        this.dgProperties!.rememberColumns=false;

      if (this.showFilterRowInitial===false)
        this.dgProperties!.filterRow=false;

      if (this.topNLimit!==undefined && this.topNLimit>0) {
        this.dgProperties!.paging              =true;
        this.dgProperties!.pageSize            =this.topNLimit;
        this.dgProperties!.allowedPageSizes    =[5, 10, 15, 20, 50, "all"];
        this.dgProperties!.pagerVisible        =true;
        this.dgProperties!.pagerDisplayMode    =<any>"full";
        this.dgProperties!.pagershowInfo       =true;
        this.dgProperties!.showPageSizeSelector=true;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgColumns(initialCreate: boolean) {
    try {
      let dgColumn    : DgColumn | undefined;
      let dataField   : string;
      let caption     : string;
      let lastColIndex: number=0;
      
      //ID
      if (initialCreate) {
        dataField            ="id";
        caption              ="ID";
        dgColumn             =this.gridViewDefaults.setUpDgColumn("id", "ID", 0, DgColumnDataType.number);
        dgColumn!.gridVisible=this.hostComponentIsDevicesAllocatedComponent &&
                              this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridShowId, false);
        dgColumn!.width      =DgColumnWidths.id;
        this.dgColumns       =[dgColumn!];
      }

      //EnteredByName
      dataField="enteredByName";
      caption  ="Entered By";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, this.curUser.userId, DgColumnDataType.string);
        dgColumn!.allowSearch=false;
        dgColumn!.formVisible=false;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =DgColumnWidths.username;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //EnteredDate
      dataField="enteredDate";
      caption  ="Entered Date";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, this.curUser.userId, DgColumnDataType.datetime);
        dgColumn!.allowSearch=false;
        dgColumn!.formVisible=false;
        dgColumn!.gridVisible=false;
        dgColumn!.sendToDB   =false;
        dgColumn!.width      =DgColumnWidths.dateWithTime;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Device Tag
      dataField="deviceTag";
      caption  ="SIM Ref";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =DgColumnWidths.tag;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //User Tag
      dataField="tag";
      caption  ="User Ref 1";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =DgColumnWidths.tag;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //User Tag2
      dataField="tag2";
      caption  ="User Ref 2";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =DgColumnWidths.tag;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //OrderNo
      dataField="orderNo";
      caption  ="Order No";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn               =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment    =DgAlignment.left;
        dgColumn!.fixed        =true;
        dgColumn!.fixedPosition="left";
        dgColumn!.gridVisible  =this.hostComponentIsDevicesAllocatedComponent;
        dgColumn!.minWidth     =DgColumnWidths.orderNo;
        dgColumn!.validators   =[Validators.required, Validators.maxLength(50)];
        dgColumn!.width        =DgColumnWidths.orderNo;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //SupplierOrderNo
      // dataField="supplierOrderNo";
      // caption  ="Supplier Order No";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
      //   dgColumn!.allowSearch=false;
      //   dgColumn!.gridVisible=false;
      //   dgColumn!.validators=[Validators.required, Validators.maxLength(50)];
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //CompanyID
      // dataField="companyID";
      // caption  ="Company";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
      //   dgColumn!.allowSearch       =false;
      //   dgColumn!.dataSource        =this.companiesService.idAndDescriptionLookupDataSource();
      //   dgColumn!.dataSourceForAForm=this.companiesService.getIdAndDescription();
      //   dgColumn!.gridVisible=false;
      //   dgColumn!.validators=[Validators.required, Validators.maxLength(50)];
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //CompanyName
      dataField="companyName";
      caption  ="Company";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.autoWidth       =this.hostShowsAsDashboard;
        dgColumn!.cellTemplate    ="CompanyNameTemplate";
        dgColumn!.cellTemplateType="link";
        dgColumn!.fixed           =true;
        dgColumn!.fixedPosition   ="left";
        
        if (this.hostComponentIsTravelRiskManagementComponent)
          dgColumn!.gridVisible=this.companyColumnIsUseful();
        
        if (this.hostShowsAsDashboard) {
          dgColumn!.width=DgColumnWidths.companyName;
        } else {
          dgColumn!.minWidth=DgColumnWidths.companyName - 30;
          dgColumn!.width   =DgColumnWidths.companyName - 30;
        }
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Fullname
      dataField="fullName";
      caption  =this.fieldAliasUsername.trim()=="" ? "Username" : this.fieldAliasUsername;

      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowFullname, true)) {
        lastColIndex++;

        if (!this.dgColumns.find(x => x.dataField==dataField)) {
          dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
          dgColumn!.autoWidth       =this.hostShowsAsDashboard;
          dgColumn!.cellTemplate    ="FullNameTemplate";
          dgColumn!.cellTemplateType="link";
          dgColumn!.fixed           =true;

          if (this.intuneExceptionColumn==dataField)
            dgColumn!.cellIcon=this.mdmIntuneSimExceptionsService.getAssignmentExceptionIcon;
          
          dgColumn!.fixedPosition   ="left";

          if (this.hostShowsAsDashboard) {
            dgColumn!.width=DgColumnWidths.username;
          } else {
            dgColumn!.minWidth=DgColumnWidths.username-30;
            dgColumn!.width   =DgColumnWidths.username-30;        
          }

          //this.dgColumns.push(dgColumn!);
          this.dgColumns.splice(lastColIndex, 0, dgColumn!);
        }
      } else {
        this.dgColumns=this.dgColumns.filter(c => c.dataField !== dataField);
      }

      //UserName
      dataField="username";
      caption  ="User";

      if (this.configSystemService.getValueAsBoolean(ConfigSystemParams.GridManageEsimShowUsername, false)) {
        lastColIndex++;
        
        if (!this.dgColumns.find(x => x.dataField==dataField)) {
          dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
          dgColumn!.autoWidth       =this.hostShowsAsDashboard;
          dgColumn!.cellTemplate    ="UserNameTemplate";
          dgColumn!.cellTemplateType="link"

          if (this.intuneExceptionColumn==dataField)
            dgColumn!.cellIcon=this.mdmIntuneSimExceptionsService.getAssignmentExceptionIcon;

          if (this.hostShowsAsDashboard)
            dgColumn!.width=DgColumnWidths.username;

          //this.dgColumns.push(dgColumn!);
          this.dgColumns.splice(lastColIndex, 0, dgColumn!);
        }
      } else {
        this.dgColumns=this.dgColumns.filter(c => c.dataField !== dataField);
      }

      //DeviceID
      // dataField="deviceID";
      // caption  ="ICCID";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
      //   dgColumn!.allowSearch       =false;
      //   dgColumn!.gridVisible       =false;
      //   dgColumn!.dataSource        =this.devicesService.idAndDescriptionLookupDataSource();
      //   dgColumn!.dataSourceForAForm=this.devicesService.getIdAndDescription();
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //ImeiIccid
      dataField="imeiIccid";
      caption  ="ICCID";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.cellTemplate    ="ICCIDTemplate";
        dgColumn!.cellTemplateType="link"
        dgColumn!.fixed           =this.hostComponentIsUsageDashboardComponent;
        dgColumn!.fixedPosition   ="left";
        dgColumn!.width           =172;

        if (this.hostShowsAsDashboard)
          dgColumn!.width=DgColumnWidths.iccic;

        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Imei
      dataField="imei";
      caption  ="IMEI";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.width           =135;
        dgColumn!.gridVisible     =false;

        if (this.hostShowsAsDashboard)
          dgColumn!.width=DgColumnWidths.imei;

        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //DeviceTypeID
      // dataField="deviceTypeID";
      // caption  ="Type";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
      //   dgColumn!.allowSearch       =false;
      //   dgColumn!.dataSourceForAForm=this.typesDeviceService.getIdAndDescription();
      //   dgColumn!.gridVisible       =false;
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //DeviceType
      dataField="deviceType";
      caption  ="Type";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.gridVisible   =this.hostComponentIsDevicesAllocatedComponent;
        dgColumn!.hidingPriority=5;
        dgColumn!.minWidth      =65;
        dgColumn!.width         =65;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //ProductID
      // dataField="productID";
      // caption  ="Product";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
      //   dgColumn!.dataSource        =this.productsService.idAndDescriptionLookupDataSource();
      //   dgColumn!.dataSourceForAForm=this.productsService.getIdAndDescription();
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //Product
      dataField="internalProductName";
      caption  ="Product";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.hidingPriority=8;
        //this.dgColumns.push(dgColumn!);
        if (this.hostShowsAsDashboard) {
          dgColumn!.minWidth    =DgColumnWidths.product;
          dgColumn!.width       =DgColumnWidths.product;
        } else {
          dgColumn!.minWidth    =250;
          dgColumn!.width       =250;
        }
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //ProvisionedDate
      dataField="provisionedDate";
      caption  ="Provisioned";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, null, DgColumnDataType.date);
        dgColumn!.customizeText =(args:any) => {
          return this.datePipe.transform(args.value, 'dd/MM/yyyy HH:mm:ss');
        };
        dgColumn!.format        ="dd/MM/yyyy";
        dgColumn!.gridVisible   =this.hostComponentIsDevicesAllocatedComponent;
        dgColumn!.hidingPriority=4;
        dgColumn!.width         =150;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //DeprovisionedDate
      dataField="deprovisionedDate";
      caption  ="Ceased";

      if (this.activeId==this.navItemLog_Ceased) {
        lastColIndex++;
        
        if (!this.dgColumns.find(x => x.dataField==dataField)) {
          dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, null, DgColumnDataType.date);
          dgColumn!.allowSearch=false;dgColumn!.customizeText = (args:any) => {
            return this.datePipe.transform(args.value, 'dd/MM/yyyy HH:mm:ss');
          };
          dgColumn!.format="dd/MM/yyyy";
          dgColumn!.width =150;
          //this.dgColumns.push(dgColumn!);
          this.dgColumns.splice(lastColIndex, 0, dgColumn!);
        }
      } else {
        this.dgColumns=this.dgColumns.filter(c => c.dataField !== dataField);
      }

      //ReleasedDate
      dataField="releasedDate";
      caption  ="Released";

      if (this.activeId==this.navItemLog_Live) {
        lastColIndex++;
        
        if (!this.dgColumns.find(x => x.dataField==dataField)) {
          dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, null, DgColumnDataType.date);
          dgColumn!.allowSearch   =false;
          dgColumn!.customizeText =(args:any) => {
            return this.datePipe.transform(args.value, 'dd/MM/yyyy HH:mm:ss');
          };
          dgColumn!.format        ="dd/MM/yyyy";
          dgColumn!.gridVisible   =this.hostComponentIsDevicesAllocatedComponent;
          dgColumn!.hidingPriority=1;
          dgColumn!.width         =150;
          //this.dgColumns.push(dgColumn!);
          this.dgColumns.splice(lastColIndex, 0, dgColumn!);
        }
      } else {
        this.dgColumns=this.dgColumns.filter(c => c.dataField !== dataField);
      }

      //Usage
      dataField="orderSpendDTO.usage";
      caption  ="Usage (MB)";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
        dgColumn!.alignment     =DgAlignment.right;
        dgColumn!.hidingPriority=10;
        dgColumn!.minWidth      =120;
        dgColumn!.summaryType   =(this.hostComponentIsDashboardComponent && this.showSummaryUsage) ? DgSummaryType.sum : DgSummaryType.none;
        dgColumn!.width         =120;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Cost
      dataField="orderSpendDTO.cost";
      caption  ="Cost";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                       =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
        dgColumn!.alignment            =DgAlignment.right;
        dgColumn!.calculateDisplayValue=(rowData: any) => rowData?.orderSpendDTO?.costWithCurrencySymbol ?? rowData?.orderSpendDTO?.cost;
        dgColumn!.calculateSortValue   =(rowData: any) => Number(rowData?.orderSpendDTO?.cost ?? 0);
        dgColumn!.hidingPriority       =9;
        dgColumn!.summaryType          =(this.hostComponentIsDashboardComponent && this.showSummaryCost) ? DgSummaryType.sum : DgSummaryType.none;
        dgColumn!.summaryValueFormat   ={ type: 'fixedPoint', precision: 2 };

        if (this.hostShowsAsDashboard) {
          dgColumn!.minWidth=DgColumnWidths.numberMedium;
          dgColumn!.width   =DgColumnWidths.numberMedium;
        }
        else {
          dgColumn!.minWidth=68;
          dgColumn!.width   =68;
        }

        dgColumn!.sortOrder=DgColumnSortOrder.desc;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //UsageLimit
      dataField="orderSpendDTO.usageLimitDisplay";
      caption  ="Limit";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=this.hostComponentIsDevicesAllocatedComponent || this.showUsageLimitColumn;
        dgColumn!.minWidth   =90;
        dgColumn!.width      =90;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LimitUsed
      dataField="orderSpendDTO.limitUsed";
      caption  ="Limit Used %";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                       =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
        dgColumn!.alignment            =DgAlignment.right;
        dgColumn!.calculateCellValue   =(rowData: any) => {
          const typeName=(rowData?.orderSpendDTO?.limitTypeName ?? "").toLowerCase();
          if (typeName===LimitTypeName.Spend.toLowerCase()) return rowData?.orderSpendDTO?.limitUsed     ?? null;
          if (typeName===LimitTypeName.Data.toLowerCase() ) return rowData?.orderSpendDTO?.dataLimitUsed ?? null;
          return null;
        };
        dgColumn!.gridVisible   =this.hostComponentIsDevicesAllocatedComponent || this.showLimitUsedColumn;
        dgColumn!.hidingPriority=6;
        dgColumn!.minWidth      =105;
        dgColumn!.width         =105;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LimitTypeName
      dataField="orderSpendDTO.limitTypeName";
      caption  ="Limit Type";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =115;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LimitTypeName
      dataField="orderSpendDTO.limitTypeName";
      caption  ="Limit Type";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.alignment  =DgAlignment.right;
        dgColumn!.gridVisible=false;
        dgColumn!.width      =115;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LastCountryFlagIcon
      dataField="orderSpendDTO.lastCountryFlagIcon";
      caption  ="Last Country";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                     =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.allowSearch        =false;
        dgColumn!.gridVisible        =false;
        dgColumn!.showInColumnChooser=false;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LastCountry
      dataField="orderSpendDTO.lastCountry";
      caption  ="Last Country";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.cellTemplate    ="LastCountryTemplate";
        dgColumn!.cellTemplateType="imageAndValue"
        dgColumn!.hidingPriority  =2;
        dgColumn!.imageColumn     ="orderSpendDTO.lastCountryFlagIcon"
        dgColumn!.width           =152;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LastUsage
      dataField="orderSpendDTO.lastUsage";
      caption  ="Last Usage";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, null, DgColumnDataType.date);
        dgColumn!.customizeText =(args:any) => {
          return this.datePipe.transform(args.value, 'dd/MM/yyyy HH:mm:ss');
        };
        dgColumn!.format        ="dd/MM/yyyy";
        dgColumn!.gridVisible   =this.hostComponentIsDevicesAllocatedComponent || this.showLastUsageColumn;
        dgColumn!.hidingPriority=3;
        dgColumn!.width         =150;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //LocationAccuracyDisplay
      dataField="locationAccuracyDisplay";
      caption  ="Location Level";
      lastColIndex++;

      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.cellIcon          =this.locationAccuracyIcon;
        dgColumn!.cellTemplate      ="LocationAccuracyTemplate";
        dgColumn!.cellTemplateType  ="iconAndValue";
        dgColumn!.calculateSortValue=(rowData: any) => rowData?.locationAccuracyLevelEffective ?? 0;
        dgColumn!.gridVisible       =false;
        dgColumn!.hidingPriority    =4;
        dgColumn!.minWidth          =140;
        dgColumn!.width             =140;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //DeviceModelDisplay
      if (this.hostComponentIsTravelRiskManagementComponent) {
        dataField="deviceModelDisplay";
        caption  ="Device";
        lastColIndex++;

        if (!this.dgColumns.find(x => x.dataField==dataField)) {
          dgColumn                =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
          dgColumn!.gridVisible   =false;
          dgColumn!.hidingPriority=5;
          dgColumn!.minWidth      =150;
          dgColumn!.width         =undefined;
          this.dgColumns.splice(lastColIndex, 0, dgColumn!);
        }
      }

      ["locationAccuracyLevelEffective", "locationServicesEnabled"].forEach((helperField: string) => {
        lastColIndex++;

        if (!this.dgColumns.find(x => x.dataField==helperField)) {
          const helperColumn=this.gridViewDefaults.setUpDgColumn(helperField, helperField, "", DgColumnDataType.string);

          helperColumn!.allowSearch        =false;
          helperColumn!.gridVisible        =false;
          helperColumn!.showInColumnChooser=false;
          this.dgColumns.splice(lastColIndex, 0, helperColumn!);
        }
      });

      //StatusID
      // dataField="statusID";
      // caption  ="Status";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn                    =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.number);
      //   dgColumn!.dataSource        =this.typesOrderStatusService.idAndDescriptionLookupDataSource();
      //   dgColumn!.dataSourceForAForm=this.typesOrderStatusService.getIdAndDescription();
      //   dgColumn!.width             =75;
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //Status
      dataField="statusDisplay";
      caption  ="Status";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                  =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
        dgColumn!.cellIcon        =(rowData: any) => this.simStatusService.getIcon(rowData); //RBW_20260824
        dgColumn!.cellTemplate    ="SimStatusTemplate";
        dgColumn!.cellTemplateType="iconAndValue";
        dgColumn!.hidingPriority  =11;

        dgColumn!.minWidth=DgColumnWidths.simStatus;
        dgColumn!.width   =DgColumnWidths.simStatus;

        if (!this.hostShowsAsDashboard)
          dgColumn!.filterValues=this.simStatusService.toStatusDisplays(this.liveStatues); //RBW_2025MMDD - Initial filter values for this column

        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //EID
      // dataField="eid";
      // caption  ="EID";
      // lastColIndex++;
      
      // if (!this.dgColumns.find(x => x.dataField==dataField)) {
      //   dgColumn             =this.gridViewDefaults.setUpDgColumn(dataField, caption, "", DgColumnDataType.string);
      //   dgColumn!.allowSearch=false;
      //   dgColumn!.gridVisible=false;
      //   dgColumn!.validators =[Validators.required, Validators.maxLength(32)];
      //   //this.dgColumns.push(dgColumn!);
      //   this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      // }

      //Active
      dataField="active";
      caption  ="Active";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                     =this.gridViewDefaults.setUpDgColumn(dataField, caption, true, DgColumnDataType.boolean);
        dgColumn!.allowSearch        =false;
        dgColumn!.dataSource         =this.booleanService.idAndDescriptionLookupDataSource();
        dgColumn!.dataSourceForAForm =this.booleanService.getIdAndDescription();
        dgColumn!.gridVisible        =false;
        dgColumn!.showInColumnChooser=false;
        dgColumn!.validators         =[Validators.required];
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Deprovisioned
      dataField="deprovisioned";
      caption  ="Ceased";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                     =this.gridViewDefaults.setUpDgColumn(dataField, caption, true, DgColumnDataType.boolean);
        dgColumn!.allowSearch        =false;
        dgColumn!.dataSource         =this.booleanService.idAndDescriptionLookupDataSource();
        dgColumn!.dataSourceForAForm =this.booleanService.getIdAndDescription();
        dgColumn!.gridVisible        =false;
        dgColumn!.showInColumnChooser=false;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      //Released
      dataField="released";
      caption  ="Released";
      lastColIndex++;
      
      if (!this.dgColumns.find(x => x.dataField==dataField)) {
        dgColumn                     =this.gridViewDefaults.setUpDgColumn(dataField, caption, true, DgColumnDataType.boolean);
        dgColumn!.allowSearch        =false;
        dgColumn!.dataSource         =this.booleanService.idAndDescriptionLookupDataSource();
        dgColumn!.dataSourceForAForm =this.booleanService.getIdAndDescription();
        dgColumn!.gridVisible        =false;
        dgColumn!.showInColumnChooser=false;
        //this.dgColumns.push(dgColumn!);
        this.dgColumns.splice(lastColIndex, 0, dgColumn!);
      }

      this.applyTravelRiskColumnVisibility();
      this.applyTravelRiskColumnOrder();
      this.applyTravelRiskColumnWidths();
      this.assignColumnVisibleIndexes();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyTravelRiskColumnVisibility(): void {
    try {
      if (!this.hostComponentIsTravelRiskManagementComponent)
        return;

      this.dgColumns.forEach((column: DgColumn) => {
        column.gridVisible=this.travelRiskColumnIsVisible(column.dataField);
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyTravelRiskColumnWidths(): void {
    try {
      if (!this.hostComponentIsTravelRiskManagementComponent)
        return;

      const stretchColumn=this.dgColumns?.find(x => x.dataField=="fullName");

      if (stretchColumn!=undefined) {
        stretchColumn.minWidth=DgColumnWidths.username-30;
        stretchColumn.width   =undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyTravelRiskColumnOrder(): void {
    try {
      if (!this.hostComponentIsTravelRiskManagementComponent)
        return;

      const order: string[]=this.travelRiskVisibleColumns();

      const rank=(column: DgColumn): number => {
        if (column.dataField=="companyName")
          return -1;

        const index: number=order.indexOf(column.dataField);

        return index<0 ? order.length : index;
      };

      this.dgColumns.sort((a: DgColumn, b: DgColumn) => rank(a)-rank(b));
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private assignColumnVisibleIndexes(): void {
    try {
      let index=0;

      this.dgColumns
        .filter(c => c.fixed===true)
        .forEach(c => c.visibleIndex=index++);

      this.dgColumns
        .filter(c => c.fixed!==true)
        .forEach(c => c.visibleIndex=index++);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private setUpDgTabs() {
    try {
      let dgTab: DgTab | undefined;
      
      //Live
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Live, "Live");
      this.dgTabs       =[dgTab!];

      //Deprovisioned
      dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Ceased, "Ceased");
      this.dgTabs.push(dgTab!);

      //Removed
      // dgTab             =this.gridViewDefaults.setUpDgTab(this.navItemLog_Removed, "Removed");
      // this.dgTabs.push(dgTab!);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public cellClick(e : any)
  {
    try {
      if (e != undefined)
      {
        if (e.column.name == "companyName") {
          this.companyClick(e.row.data["companyName"])
        }

        if (e.column.name == "fullName") {
          this.userClick(e.row.data["companyName"], e.row.data["username"])
        }

        if (e.column.name == "imeiIccid") {
          this.gridEditButtonClick(e)
        }

        if (e.column.name == "username") {
          this.userClick(e.row.data["companyName"], e.row.data["username"])
        }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Risk Intelligence

  public gridLocationButtonClick(e: any): void {
    try {
      if (this.manageEsimFormIsOpen)
        return;

      const orderId: number=Number(e?.row?.data?.id ?? 0);

      if (orderId<=0)
        throw new Error("DevicesAllocatedContentSharedComponent.gridLocationButtonClick() - SureSIM order id cannot be determined");

      this.manageEsimFormIsOpen=true;
      this.disableGridLoadPanel();
      this.manageEsimModalForm.openForm(orderId, true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridMessageButtonClick(e: any): void {
    try {
      const rowData          =e?.row?.data;
      const userId   : number=Number(rowData?.userID ?? 0);
      const companyId: number=Number(rowData?.companyID ?? 0);

      if (userId<=0)
        return;

      this.communicationComposeModalForm?.openForm(companyId, userId);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridRiskButtonClick(e: any): void {
    try {
      this.openRiskTripReadyFromRow(e?.row?.data);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public manageEsimRiskButtonClick(payload: { lastCountry: string; companyID: number; }): void {
    try {
      this.openRiskTripReadyFromRow({ orderSpendDTO: { lastCountry: payload?.lastCountry ?? '' }, companyID: payload?.companyID ?? 0 });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async openRiskTripReadyFromRow(rowData: any): Promise<void> {
    try {
      if (this.riskTripReadyModalFormIsOpen)
        return;

      const lastCountryName: string=rowData?.orderSpendDTO?.lastCountry ?? '';
      const rowCompanyId   : number=Number(rowData?.companyID ?? 0);
      const destinationIso : string=this.resolveIsoFromCountryName(lastCountryName);
      const originIso      : string=await this.resolveOriginIsoForCompany(rowCompanyId);
      const today          : string=this.todayIsoDate();

      this.riskTripReadyModalFormIsOpen=true;
      this.riskTripReadyModalForm.openForm({
        destinationIso: destinationIso,
        fromDate      : today,
        originIso     : originIso,
        toDate        : today
      });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private async resolveOriginIsoForCompany(companyId: number): Promise<string> {
    try {
      if (!companyId || companyId<=0)
        return this.originIsoCached;

      if (this.countriesService.allCountries===undefined || this.countriesService.allCountries.length===0) {
        const countries=await firstValueFrom(this.countriesService.get()
                              .pipe(
                                catchError((error) => {
                                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                                })
                              )
                             );

        this.countriesService.allCountries=countries;
      }

      const company=await firstValueFrom(this.companiesService.getById(companyId)
                          .pipe(
                            catchError((error) => {
                              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                            })
                          )
                         );

      const companyCountryId: number=company?.countryID ?? 0;
      const country                 =this.countriesService.allCountries?.find(c => c.id===companyCountryId);

      return country?.alpha2Code?.toLowerCase() ?? '';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  public riskTripReadyFormHasBeenCancelled(): void {
    try {
      this.riskTripReadyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private resolveIsoFromCountryName(countryName: string): string {
    try {
      if (!countryName)
        return '';

      const id: number | undefined=this.countriesService.getIdFromCountry(countryName);

      if (id===undefined || id<=0)
        return '';

      const country=this.countriesService.allCountries?.find(c => c.id===id);

      return country?.alpha2Code?.toLowerCase() ?? '';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  private async resolveOriginCountryIso(): Promise<void> {
    try {
      if (!this.showRiskColumn)
        return;

      if (this.countriesService.allCountries===undefined || this.countriesService.allCountries.length===0) {
        const countries=await firstValueFrom(this.countriesService.get()
                              .pipe(
                                catchError((error) => {
                                  return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                                })
                              )
                             );

        this.countriesService.allCountries=countries;
      }

      const company=await firstValueFrom(this.companiesService.getById(this.curUser.companyId)
                          .pipe(
                            catchError((error) => {
                              return throwError(() => new Error(this.exceptionsService.formatHttpError(error)));
                            })
                          )
                         );

      const companyCountryId: number=company?.countryID ?? 0;
      const country                 =this.countriesService.allCountries?.find(c => c.id===companyCountryId);

      this.originIsoCached=country?.alpha2Code?.toLowerCase() ?? '';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private locationAccuracyIcon=(rowData: any): DgCellIcon | undefined => {
    try {
      if (rowData?.locationServicesEnabled===false)
        return { colourClass: "text-muted", iconClass: "ri-indeterminate-circle-line" };

      switch (rowData?.locationAccuracyLevelEffective) {
        case 1:
          return { colourClass: "text-muted", iconClass: "ri-global-line" };
        case 2:
          return { colourClass: "text-info", iconClass: "ri-building-line" };
        case 3:
          return { colourClass: "text-success", iconClass: "ri-pulse-line" };
        default:
          return undefined;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return undefined;
    }
  };

  private locationColumnCondition=(rowData: any): boolean => {
    try {
      return Number(rowData?.id ?? 0)>0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  private messageColumnCondition=(rowData: any): boolean => {
    try {
      return Number(rowData?.userID ?? 0)>0;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  private riskColumnCondition=(rowData: any): boolean => {
    try {
      //CRN_20260522 - Riskline button only where Subscribers have last-country set
      const name=rowData?.orderSpendDTO?.lastCountry ?? '';

      return !!name;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  };

  private todayIsoDate(): string {
    try {
      const now=new Date();
      const yyyy=now.getFullYear();
      const mm  =String(now.getMonth() + 1).padStart(2, '0');
      const dd  =String(now.getDate()     ).padStart(2, '0');

      return `${yyyy}-${mm}-${dd}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return '';
    }
  }

  //#endregion

  //#region Company Modal

  //#region Bulk SIM Actions

  private applyBulkSelectionMode(): void {
    try {
      if (this.dgProperties==undefined) {
        return;
      }

      this.dgProperties.selectionCheckBoxMode=(this.showBulkToolbar && !this.isReseller)
                                              ? DgSelectionCheckBoxMode.always
                                              : DgSelectionCheckBoxMode.none;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCompanyDropDownChange2(event: CompanySelectEvent): void {
    try {
      this.isReseller=event?.isReseller ?? false;

      if (this.isReseller) {
        this.selectedSims=[];
        this.gridView?.dataGrid?.instance?.clearSelection();
      }

      this.applyBulkSelectionMode();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onGridSelectionChanged(rows: any[]): void {
    try {
      this.selectedSims=rows ?? [];
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public openBulkAction(action: BulkSimAction): void {
    try {
      if (!this.canBulkAction) {
        return;
      }

      this.bulkSimActions.openForm(action, this.selectedSims);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onBulkCompleted(): void {
    try {
      this.selectedSims=[];
      this.gridView?.dataGrid?.instance?.clearSelection();
      this.gridView?.refreshData();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public companyClick(companyName : string) {
    try {
      if (!this.companyModalFormIsOpen) {
        this.companyModalFormIsOpen=true;
        
        this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            this.companyModalForm.openForm(data.result);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }        
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyDataHasBeenSaved(sureSimCompanyId: number | undefined) {
    try {
      this.companyModalFormIsOpen=false;
      this.gridView?.refreshData();
      this.companyDataSaved.emit();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public companyFormHasBeenCancelled() {
    try {
      this.companyModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async companyDropDownOnChange(companyID: number, skipIfUnchanged: boolean=true) {
    try {
      this.filterCompanyID=!this.superHierarchyEnabled &&
                           (companyID==null || 
                            companyID==undefined ||
                            companyID<=0)
                           ?
                           0 - this.curUser.companyId
                           :
                           companyID;
      
      this.dropdownService.trackerCompanyId=this.filterCompanyID;
      
      await this.setDgApiPathGet(skipIfUnchanged);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
       return (undefined);
    }
  }

  //#endregion

  public async dateFilterChanged(selectedDate: OurDate) {
    try {
      this.filterDate=selectedDate;

      if (!this.isCurrentMonth && this.statIsCurrentMonthOnly(this.selectedStat))
        this.selectedStat='';

      await this.setDgApiPathGet(true);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Manage SIM Modal (View Button)
  
  public gridAddButtonClick(e:any) {
    try {
      if (!this.manageEsimFormIsOpen) {
        this.manageEsimFormIsOpen=true;
        this.disableGridLoadPanel();
        this.gridView.dataGrid.instance.endCustomLoading
        this.manageEsimModalForm.openForm(0);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public enableGridLoadPanel() {
    try {
      this.dgProperties!.loadPanel             =true;
      this.dgProperties!.loadPanelShowIndicator=true;
      this.dgProperties!.loadPanelShowPane     =true;
      this.dgProperties!.loadPanelText         ="Loading...";
      this.gridView.dgProperties               =this.dgProperties;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public disableGridLoadPanel() {
    try {
      this.dgProperties!.loadPanel             =false;
      this.dgProperties!.loadPanelShowIndicator=false;
      this.dgProperties!.loadPanelShowPane     =false;
      this.dgProperties!.loadPanelText         ="";
      this.gridView.dgProperties               =this.dgProperties;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public gridEditButtonClick(e:any) {
    try {
      if (!this.manageEsimFormIsOpen) {
        let orderNo: string | undefined = e.row.data["orderNo"];

        if (orderNo==undefined || (<string>orderNo).trim()=="") {
          throw new Error("DevicesAllocatedContentSharedComponent..SureSIM OrderNo cannot be determined");
        }

        this.manageEsimFormIsOpen=true;
        this.disableGridLoadPanel();
        this.manageEsimModalForm.openFormByOrderNo(<string>orderNo);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async orderDataHasBeenSaved() {
    try {
      this.manageEsimFormIsOpen=false;
      this.enableGridLoadPanel();
      
      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async orderStatusHasBeenUpdated() {
    try {     
      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public manageEsimFormHasBeenCancelled() {
    try {
      this.manageEsimFormIsOpen=false;
      this.enableGridLoadPanel();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  //#region More (Manage Button)

  public gridMoreButtonClick(e: any) {
    try {
      this.devExtremeMoreEvent=e;

      //RBW_20260710 - On the usage dashboard the view button goes straight to the live data screen instead of opening the more menu
      if ((this.manageEsimVersion2 && this.hostComponentIsDashboardComponent) || this.hostComponentIsUsageDashboardComponent) {
        this.viewTimeline(this.devExtremeMoreEvent.row.data["imeiIccid"]);

      } else {
        // if (this.curUser.systemAdmin || this.curUser.systemAdminStd) {
          this.openMoreMenu(e);

        // } else {
        //   this.openMoreForm(e);
        // }
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }
  
  private openMoreMenu(e: any) {
    try {
      this.morePopupMenu?.menuPanel?.toggle(e.event as MouseEvent);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private onMoreMenuClick(item: string) {
    try {
      if (item==this.menuItemManageSIM) {
        this.openMoreForm(this.devExtremeMoreEvent);
      
      } else {
        this.viewTimeline(this.devExtremeMoreEvent.row.data["imeiIccid"]);
      }

      this.morePopupMenu.menuPanel.hide();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private openMoreForm(e: any) {
    try {
      if (!this.manageMoreFormIsOpen) {
        let orderId: number | undefined = e.row.data["id"];
      
        if (orderId==undefined || <number>orderId<=0) {
          throw new Error("DevicesAllocatedContentSharedComponent..SureSIM OrderID cannot be determined");
        }
        
        let sureSimOrderDetails: OrderMiniDTO={
          alertProduct : "",
          iccid        : e.row.cells[this.gridView.dataGrid.instance.getVisibleColumnIndex("imeiIccid")].text,
          orderID      : orderId,
          orderNo      : e.row.cells[this.gridView.dataGrid.instance.getVisibleColumnIndex("orderNo")].text,
          status       : e.row.data["status"],
          statusDisplay: e.row.data["statusDisplay"],
          statusIcon   : e.row.data["statusIcon"],
          username     : e.row.data["username"],
          systemUserID : this.curUser.userId
        }
        
        this.manageMoreFormIsOpen=true;
        this.manageEsimMore.openForm(sureSimOrderDetails);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public moreFormHasBeenSaved() {
    try {
      this.manageMoreFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async moreFormHasBeenCancelled(refreshGrid:boolean) {
    try {
      this.manageMoreFormIsOpen=false;
    
      if (refreshGrid)
        await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion

  public viewTimeline(iccid: string) {
    try {
      if (this.showTimelineAsModal) {
        this.timelineModalForm.openForm(iccid);
        
      } else {
        this.router.navigate(["/timeline/esim-timeline", EncryptAesClientSide(iccid)]);
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userClick(companyName: string, username : string) {
    try {
      if (!this.userModalFormIsOpen) {
        this.userModalFormIsOpen=true;
        
        this.companiesService.getIdByCompanyName(companyName)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: data => {
            const companyId: number=data.result;

            this.usersService.getIdByUsername(companyId, username)
            .pipe(
              catchError((error) => {
                return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
              })
            )
            .subscribe({
              next: data => {
                this.userModalForm.openForm(data.result, eUser.sim);
              },
              error: error => {
                this.exceptionsService.handleException(new Error(error));
              }
            });
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }       
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userDataHasBeenSaved(sureSimUserId: number | undefined) {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public userFormHasBeenCancelled() {
    try {
      this.userModalFormIsOpen=false;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public iccidClicked(iccid : string) {
    try {
      if (!this.manageEsimFormIsOpen) {
        this.ordersService.getOrderIdByIccid(iccid)
        .pipe(
          catchError((error) => {
            return throwError(() => new Error(this.exceptionsService.formatHttpError(error)))
          })
        )
        .subscribe({
          next: orderIdResult => {
            const orderId=Number(orderIdResult?.result ?? -1);
  
            if (!Number.isFinite(orderId) || orderId <= 0) {
              return;
            }
  
            this.manageEsimFormIsOpen=true;
            this.disableGridLoadPanel();
            this.manageEsimModalForm.openForm(orderId);
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async onCheckbox1Change(value: boolean | number | string): Promise<void> {
    try {
      this.dgProperties!.checkbox1!.value=value;
      this.includeCeased                 =value===true;

      await this.setDgApiPathGet();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public onCheckboxChange(value: boolean | number | string): void {
    try {
      const on              =value===true;
      const hidingEnabled   =!on;

      this.dgProperties!.checkbox0!.value   =value;
      this.dgProperties!.columnHidingEnabled=hidingEnabled;
      this.dgProperties!.columnMinWidth     =on ? this.columnMinWidth : undefined;

      this.gridView.setColumnMinWidth(this.dgProperties!.columnMinWidth, this.dgActionColumn!.width);
      this.gridView.setColumnHidingEnabled(hidingEnabled);
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#region Stats

  private applyGridFilter(): void {
    try {
      if (this.selectedStat)
        this.applyStatFilter();
      else
        this.applyTabStatusFilter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyTabStatusFilter(): void {
    try {
      const gridInstance=this.gridView?.dataGrid?.instance;

      if (!gridInstance)
        return;

      const desired: any=this.activeId===this.navItemLog_Ceased ? ['status', '=', 'Ceased'] : ['status', '<>', 'Ceased'];
      let   current: any=null;

      try { current=gridInstance.filter(); } catch { current=null; }

      if (JSON.stringify(current ?? null) !== JSON.stringify(desired))
        gridInstance.filter(desired);

      this.appliedFilterKey=`tab|${this.activeId}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private applyStatFilter(): void {
    try {
      const gridInstance=this.gridView?.dataGrid?.instance;

      if (!gridInstance)
        return;

      //RBW_20260826 - If a stat is selected: its function-based filters can't be compared, so guard by key to avoid re-applying (and looping) on every contentReady
      const year =<number>(this.filterDate?.year  ?? 0);
      const month=<number>(this.filterDate?.month ?? 0);
      const key  =`${this.activeId}|${this.selectedStat}|${year}|${month}`;

      if (key===this.appliedFilterKey)
        return;

      this.appliedFilterKey=key;

      const threshold=this.effectiveNearLimitThreshold;

      switch (this.selectedStat) {
        case 'active':
          gridInstance.filter(['status', '=', 'Live']);
          break;
        case 'alerting':
          gridInstance.filter(['status', 'startswith', 'Live - ']);
          break;
        case 'awaiting':
          gridInstance.filter((item: any) =>
            item?.status==='Awaiting Download' ||
            item?.status==='Awaiting Deployment' ||
            item?.status==='Downloaded'        ||
            item?.status==='Sent - SMS/email'
          );
          break;
        case 'ceasedThisMonth': {
          const y         =<number>(this.filterDate?.year  ?? 0);
          const m         =<number>(this.filterDate?.month ?? 0);
          const monthStart=new Date(y, m - 1, 1, 0, 0, 0);
          const nextMonth =new Date(y, m,     1, 0, 0, 0);

          gridInstance.filter((item: any) => {
            if (item?.status!=='Ceased')
              return false;

            const raw=item?.deprovisionedDate;

            if (!raw)
              return false;

            const d=raw instanceof Date ? raw : new Date(raw);

            return d>=monthStart && d<nextMonth;
          });
          break;
        }
        case 'overLimit':
          gridInstance.filter((item: any) =>
            Number(item?.orderSpendDTO?.limitUsed ?? 0)>=100
          );
          break;
        case 'nearLimit':
          gridInstance.filter((item: any) => {
            const pct=Number(item?.orderSpendDTO?.limitUsed ?? 0);
            return pct>=threshold && pct<100;
          });
          break;
        case 'zeroUsage':
          gridInstance.filter((item: any) =>
            (item?.status==='Live' || String(item?.status ?? '').startsWith('Live - ')) &&
            Number(item?.orderSpendDTO?.usage ?? 0)===0
          );
          break;
        case 'newToday': {
          const now       =new Date();
          const todayStart=new Date(now.getFullYear(), now.getMonth(), now.getDate(),     0, 0, 0);
          const tomorrow  =new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0);
          gridInstance.filter((item: any) => {
            const raw=item?.provisionedDate;

            if (!raw)
              return false;

            const d=raw instanceof Date ? raw : new Date(raw);

            return d>=todayStart && d<tomorrow;
          });
          break;
        }
        case 'newInMonth': {
          const y         =<number>(this.filterDate?.year  ?? 0);
          const m         =<number>(this.filterDate?.month ?? 0);
          const monthStart=new Date(y, m - 1, 1, 0, 0, 0);
          const nextMonth =new Date(y, m,     1, 0, 0, 0);

          gridInstance.filter((item: any) => {
            const raw=item?.provisionedDate;

            if (!raw)
              return false;

            const d=raw instanceof Date ? raw : new Date(raw);

            return d>=monthStart && d<nextMonth;
          });
          break;
        }
        default:
          gridInstance.filter(null);
          break;
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadStats(companyIdEncSS: string): void {
    try {
      const year =<number>(this.filterDate?.year  ?? 1);
      const month=<number>(this.filterDate?.month ?? 1);

      this.statsSub?.unsubscribe();
      this.statsSub=this.ordersService.getStats(companyIdEncSS, year, month, this.showCeasedCompanies && this.includeCeased)
        .pipe(
          catchError((error) => {
            this.exceptionsService.handleException(new Error(this.exceptionsService.formatHttpError(error)));
            return throwError(() => new Error(error));
          })
        )
        .subscribe({
          next : (data: OrderDevicesAllocatedStatsDTO) => {
            const safe=data ?? OrderDevicesAllocatedStatsDTO_EmptyObject();
            this.statsActive                =safe.active;
            this.statsAlerting              =safe.alerting;
            this.statsAwaiting              =safe.awaiting;
            this.statsCeasedThisMonth       =safe.ceasedThisMonth;
            this.statsNearLimit             =safe.nearLimit;
            this.statsNewInMonth            =safe.newInMonth;
            this.statsNewToday              =safe.newToday;
            this.statsOverLimit             =safe.overLimit;
            this.statsTotal                 =safe.total;
            this.statsZeroUsage             =safe.zeroUsage;
            this.effectiveNearLimitThreshold=safe.nearLimitThresholdUsed>0 ? safe.nearLimitThresholdUsed : this.nearLimitThreshold;
          },
          error: error => {
            this.exceptionsService.handleException(new Error(error));
          }
        });
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private loadStatsVisibility(): void {
    try {
      const raw=localStorage.getItem(this.statsVisibilityStorageKey());
      
      this.statsHidden=raw===null ? true : raw==='true';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  public async statClick(stat: string): Promise<void> {
    try {
      this.selectedStat=this.selectedStat===stat ? '' : stat;

      const targetTabId=this.selectedStat==='ceasedThisMonth' ? this.navItemLog_Ceased : this.navItemLog_Live;

      if (this.selectedStat && this.activeId!==targetTabId) {
        this.arrowNav?.select(targetTabId);
        await this.onTabChange(targetTabId);
      }

      this.applyGridFilter();
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  private statIsCurrentMonthOnly(stat: string): boolean {
    try {
      return stat==='active'          ||
             stat==='alerting'        ||
             stat==='awaiting'        ||
             stat==='ceasedThisMonth' ||
             stat==='newToday';
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return false;
    }
  }

  private statsVisibilityStorageKey(): string {
    try {
      return `${StorageValues.sureSimAllocatedStatsHidden_}${this.curUser?.userId ?? 0}`;
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
      return `${StorageValues.sureSimAllocatedStatsHidden_}0`;
    }
  }

  public toggleStatsVisibility(): void {
    try {
      this.statsHidden=!this.statsHidden;
      localStorage.setItem(this.statsVisibilityStorageKey(), this.statsHidden ? 'true' : 'false');

      if (this.statsHidden && this.selectedStat) {
        this.selectedStat='';
        this.applyGridFilter();
      }
    }
    catch(e) {
      this.exceptionsService.handleException(<Error>e);
    }
  }

  //#endregion
}
